import { formatCurrency } from "@angular/common";

/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
export class NrHelper {
    static equal(a: number, b: number) {
        if (a == null || b == null) {
            // If both are null or undefined, return true, otherwise if one is null or undefined return false
            return a == b; 
        }
        return Math.abs(Math.round((a - b) * 10000) / 10000) < 0.0001;
    }

    static toCurrency(a: number) {
        return Math.round(a * 100) / 100;
    }
    static toFormattedCurrency(a: number, decimals = 2) {
        return formatCurrency(NrHelper.toCurrency(a), 'EN-ie', '€', undefined, `1.${decimals}-${decimals}`);
    }
    static toOrdinal = (n: number) => `${n}${['th','st','nd','rd'][(n%100>>3^1&&n%10)||0]||'th'}`;    
}

